<script>
import { Line } from "vue-chartjs";

export default Line.extend({
  mounted() {
    this.renderChart({
      labels: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      legend: {
        display: false,
        labels: {
          filter() {
            return false;
          }
        }
      },
      tooltips: {
        displayColors: false
      },
      datasets: [
        {
          fill: false,
          borderColor: "#f87979",
          pointRadius: 4,
          lineTension: 0,
          data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11]
        }
      ]
    });
  }
});
</script>
